<section>
  <!-- wrapper -->
  <div class="h-screen w-screen">
    <div id="notfound">
      <div class="notfound">
        <div class="notfound-404">
          <h1>404</h1>
        </div>
        <h2>{{ 'We are sorry, Page not found!' | transloco }}</h2>
        <p>
          {{
            'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.'
              | transloco
          }}
        </p>
        <a class="mt-5" (click)="refresh()">{{ 'Back To Homepage' | transloco }}</a>
      </div>
    </div>
  </div>
</section>
